/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react'
import {
  WrapperMobile,
  ContainerMobile,
  ExternContainerMobile,
  Content,
  Points,
  ContainerMobileFinished,
  WrapperMobileFinished,
  IconFinished,
  PointsFinished,
  ExternContainerMobileFinished,
  MissionName, InstructionStartAsync, Separator
} from './styles'
import { MissionType } from '../../../domain/enum/mission-type.enum'
import { MissionModel } from '../../../domain/model/mission.model'
import { orderByPosition } from '../../utils/mission_helpers'
import WidgetIcons from '../../utils/icons'
import { customTheme } from '../../styles/theme'
import { useGame } from '../../contexts'
import { GameState } from '../../../domain/enum/game-state.enum'
import { t } from '../../adapters/translate/translate'
import { Icon } from '../../assets/icons'

const iconsMaps = {
  [MissionType.CONNECTIONS]: 'RiGuideFill',
  [MissionType.INPUT_TEAM]: 'RiTeamFill',
  [MissionType.INPUT_PLAYERS]: 'RiTeamFill',
  [MissionType.INPUT_TEXT]: 'RiPencilFill',
  [MissionType.INSTRUCTIONS]: 'RiVipDiamondFill',
  [MissionType.MULTIPLE_CHOICE]: 'RiListCheck',
  [MissionType.INPUT_TOTAL_PLAYERS]: 'RiListCheck',
  [MissionType.PICTURE]: 'RiCameraFill',
  [MissionType.PRIORITIZE]: 'RiVipDiamondFill',
  [MissionType.SIMPLE_TEXT]: 'RiEditFill',
  [MissionType.WELCOME]: 'RiVipDiamondFill',
  [MissionType.FILL_IN_THE_BLANK]: '',
  [MissionType.AUDIO]: 'RiMicFill'
}

type Props = {
  onAction: (mission: MissionModel) => void;
  points?: number;
  mission: MissionModel;
  hasGift?: boolean;
  finished?: boolean;
  color?: string;
  textColor?: string;
  firstMission?: boolean;
  finishedMissions?: any;
  $isMobile: boolean;
  totalMission?: number;
}

const MissionCard = ({
  onAction,
  mission,
  finished = false,
  color = customTheme.colors.purple,
  textColor,
  firstMission,
  finishedMissions,
  $isMobile,
  totalMission
}: Props) => {
  const [points, setPoints] = useState(0)
  const [earnedPoints, setEarnedPoints] = useState(0)
  const [heightLimited, setHeightLimited] = useState(false)
  const { game } = useGame()

  function loadPoints () {
    let accumulatedPoints = mission.pointsIfCorrect || 0
    let accumulatedEarnedPoints = mission.earnedPoints || 0

    mission.childMissions.sort(orderByPosition).forEach((currentValue: MissionModel) => {
      accumulatedPoints += currentValue.pointsIfCorrect || 0
      accumulatedEarnedPoints += currentValue.earnedPoints || 0
    })

    setPoints(accumulatedPoints)
    setEarnedPoints(accumulatedEarnedPoints)
  }

  useEffect(() => {
    loadPoints()

    if (totalMission) {
      if (totalMission === 2) {
        setHeightLimited(true)
      } else {
        setHeightLimited(false)
      }
    }
  }, [])

  if (finished) {
    return (
      <ExternContainerMobileFinished $isMobile={$isMobile} title={mission.name}>
        <WrapperMobileFinished $isMobile={$isMobile}>
          <ContainerMobileFinished>
            <Content>
              <WidgetIcons name={mission.iconName || iconsMaps[mission.type]} color={color} size="70%" width="70%" height="70%" type={mission.iconName ? 'iconify' : ''}/>
            </Content>

          </ContainerMobileFinished>
          <IconFinished $isMobile={$isMobile}>
            <WidgetIcons name="RiCheckLine" color="#000" size="85%" />
          </IconFinished>
        </WrapperMobileFinished>
      </ExternContainerMobileFinished>
    )
  }

  return (
    <ExternContainerMobile
      onClick={() => onAction(mission)}
      $isMobile={$isMobile}
      $heightLimited={heightLimited}
      $paddingEdit={game.gameState === GameState.APPROVAL && firstMission && (finishedMissions < 1)}
      >
      <WrapperMobile $isMobile={$isMobile}>
        <WidgetIcons name={mission.iconName || iconsMaps[mission.type]} color={color} size="70%" width="70%" height="70%" type={mission.iconName ? 'iconify' : ''}/>
      </WrapperMobile>

      <Separator $isMobile={$isMobile}></Separator>

      <MissionName color={textColor} $isMobile={$isMobile}>
        <h4>{mission?.name}</h4>
        <h5>Pontos: +{points}</h5>
      </MissionName>
      { game.gameState === GameState.APPROVAL && firstMission && (finishedMissions < 1) && (
            <InstructionStartAsync $isMobile={$isMobile}>
              <Icon name={'arrow-connection-line'} />
              <h4>{t('Comece clicando aqui')}</h4>

            </InstructionStartAsync>
      )}
    </ExternContainerMobile>
  )
}

export default MissionCard
